module.exports = __webpack_public_path__ + "static/media/FlowiseAI-Logo.68d89838.png";